import useSite from '~/client/hooks/useSite';

const useSidebarIcon = () => {
  const { isBitcasino, isEmpire } = useSite();
  const iconSize = isBitcasino ? 100 : 24;
  return { isEmpire, iconSize };
};

export default useSidebarIcon;
